import {Link} from "react-router-dom";
import Text from "@/base/Text";

const FormPrivacyPolicy = () => {

  const privacyLink = 'https://www.jeld-wen.com/en-us/about-us/general-information/privacy-policy';

  const createTagComponent = (path) => {
    if(path === undefined){
      return "button";
    }
  
    const absolutePathPattern = /^https?:\/\//i;
  
    if(absolutePathPattern.test(path))
    {
      return "a";
    }
  
    return Link;
  }

  const Tag = createTagComponent(privacyLink);

  return (
    <div className="pt-3">
      <Text css={{fontSize: "0.8889em"}}>
        LaCantina&trade; Doors will only share your information with select
        Preferred Dealers for the purpose of responding to your request.
      </Text>
      <Text css={{fontSize: "0.8889em"}}>
        Your privacy is important to us. Please review the LaCantina&trade; Doors{" "}
        <Tag to={Tag === Link ? privacyLink : null} href={Tag === 'a' ? privacyLink : null}>Privacy Policy</Tag>
      </Text>
    </div>
  );
}

FormPrivacyPolicy.propTypes = {};

export default FormPrivacyPolicy;